import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import application_inside from "./application_inside.vue";

window.tenderSaleInsidepp = createApp({
    name : "tenderAppSale",
    id : "tenderAppSale",
    components : {
        application_inside : application_inside,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);
tenderSaleInsidepp.mount('#tender_app_sale');